
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dpa",
      function () {
        return require("private-next-pages/dpa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dpa"])
      });
    }
  